<template>
<div class="banner" style="overflow:hidden">
  <v-app>
    <header>
      <v-app-bar
        app
        dark
		
      >

		<!-- <span style="background-color:red;width:100%;"> -->

			<!-- <span v-if="!if_sp || fav_filter" style="width:48px;">
			</span> -->

			<v-toolbar-title id="site_title">
				<router-link to="/" style="color:white;text-decoration: none;font-weight: bold;">
				<img src="data/img/favicon.ico" style="filter: brightness(300%);" width="20" height="20">
				Komaba-Wifi
				</router-link>
			</v-toolbar-title>
			<!-- <span> -->

			
			<router-link v-if="!fav_filter" to="/favs" style="text-decoration:none; margin-left:20px;">
				<span id="favpage_button">
				★
				</span>
			</router-link>
			<v-app-bar-nav-icon style="margin: 0 0 0 auto;" @click="drawer = true" v-if="if_sp && !fav_filter">
				<img src="data/img/menu_icon.png" width="25" height="25">
				<!-- <span id="menu_button"> Menu </span> -->
			</v-app-bar-nav-icon>
			<!-- </span> -->
		<!-- </span> -->
		<!-- <router-link v-if="fav_filter" to="/">
			<span style="padding:10px;font-size:20px">
			HOME
			</span>
		</router-link> -->
      </v-app-bar>
	<v-navigation-drawer
	v-model="drawer"
	fixed
	temporary
	>
	<Menu></Menu>
	</v-navigation-drawer>
    </header>
  </v-app>
</div>
</template>

<script>
import Menu from './Menu.vue'
import map_config from './map_config.js';
export default {
	name: 'WifiMonitor',
	props: {
		title: String,
		message: String,
		building: String,
		// ifsp: Boolean,
		fav_filter:{
			type: Boolean,
			default: true
		},
		if_sp:{
			type: Boolean,
			default: true
		}
	},
	components: {
		Menu,
	},
	methods: {
		getCookie:function(key){
			return this.$cookies.get(key)
		},
		setCookie:function(key, text){
			this.$cookies.config(60 * 60 * 24 * 30,'');
			this.$cookies.set(key, text);
		},
		setfav(){
			this.setCookie("num_fav_max", this.selectValue_fav)
			console.log(this.selectValue_fav)
		},
		setmap:function(){
			this.setCookie("num_canvas_max", this.selectValue_map)
			console.log(this.selectValue_map)
		},
	},
	data: function(){
		return{
			drawer: false,
			map_max: map_config.map_max,
			fav_max: map_config.fav_max,
			selectValue_fav: 1,
			selectValue_map: 1,
		}
	}
}
</script>

<style>
div {
	margin: 0px;
	padding: 0px;
	text-align: left;
	
}
.banner{
	/* background-color: rgb(0, 119, 255); */
	background-color: rgb(255, 255, 255);
}
h1 {
	font-size: 72pt;
	font-weight: bold;
	text-align: right;
	letter-spacing: -8px;
	color: #f0f0f0;
	margin: 0px;
}

p {
	margin: 0px;
	color:#666;
	font-size:16pt;
}
.halo-tree ul{
    /* padding-left: 17px; */
    /* padding-top: 10px */
	padding-left: 0px;
}
.v-select__selections {
     min-width: 0px
}

#favpage_button{
	padding:10px;font-size:25px;color:rgb(255, 255, 0);background-color:white;border-radius: 10px;
	-webkit-text-stroke: 1px rgb(133, 133, 133);
	height:50px;
	/* text-stroke: 1px #FFF; */
}
#favpage_button:hover{
	opacity:0.7;
}

#menu_button{
	padding:10px;font-size:15px;
	color:rgb(0, 0, 0);
	color:white;
	/* background-color:white; */
	border-radius: 10px;
	/* height:50px; */
	height:100%;
	/* -webkit-text-stroke: 1px rgb(133, 133, 133); */
	/* text-stroke: 1px #FFF; */
}
#site_title:hover{
	opacity: 0.7;
}
</style>
